export default "__VITE_ASSET__DPXI7w_N__"